import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, Link } from "react-router-dom";
import { getProfile, editUser, createVerification, createApp, createResearch, createPublication, changePass } from '../../routes/UserAction';


import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import './Profile.css';
import { domain, reduceText } from '../../data/dummyData';

export default function Profile() {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user.user);
    const search = useLocation().search;
    const id = new URLSearchParams(search).get("id");
    const [pageData, setPageData] = useState(null);
    const [activeTab, setActiveTab] = useState('verification');

    const tabs = [
        'memberships', 
        'groups', 
        'publications',
        'policies', 
        'edit profile',
        'change password', 
        'settings'
    ];

    const [formData, setFormData] = useState({
        title: '',
        about: '',
        form_id: '',
        image: null,
        file: null,

        new_password: '',
        old_password: '',
        new_email: user?.email,
        new_contact: user?.phone,
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        if (files.length > 0) {
            setFormData(prev => ({ ...prev, [name]: files[0] }));
        }
    };

    const handleSubmit = async () => {
        const form = new FormData();
        form.append('title', formData.title);
        form.append('about', formData.about);
        form.append('form_id', formData.form_id);
        form.append('image', formData.image);
        // form.append('file', formData.file);

        try {
            dispatch(createPublication(form))
            .then((res) => {
                alert("Publication submitted!");
            })
            .catch((err) => {
                console.error(err);
            });
        } catch (error) {
            console.error('Error submitting form:', error);
            // alert(error);
            alert('Something went wrong');
        }
    };



    const fetchPage = () => {
        dispatch(getProfile({ id: user?.id }))
        .then(response =>{
            let resData = response.payload.data;
            console.log('data...', resData)

            setPageData(resData);
            
        })
        .catch(console.error);
    };

    const sendVerification = () => {
        
        let verificationData = null;
        
        dispatch(createVerification(verificationData))
        .then((res) => {
            alert("Verification submitted!");
        })
        .catch((err) => {
            console.error(err);
        });
    };
    const sendApp = () => {
        
        let verificationData = null;
        
        dispatch(createApp(verificationData))
        .then((res) => {
            alert("Verification submitted!");
        })
        .catch((err) => {
            console.error(err);
        });
    };
    const sendResearch = () => {
        
        let verificationData = null;
        
        dispatch(createResearch(verificationData))
        .then((res) => {
            alert("Verification submitted!");
        })
        .catch((err) => {
            console.error(err);
        });
    };

    const sendProfile = () => {
        
        dispatch(editUser({
            email: formData.new_email,
            phone: formData.new_contact,
        }))
        .then((res) => {
            alert("submitted!");
        })
        .catch((err) => {
            console.error(err);
        });
    };

    const sendPassword = () => {
        
        dispatch(changePass({
            password: formData.new_password,
            // new_password: formData.new_password,
        }))
        .then((res) => {
            alert("submitted!");
        })
        .catch((err) => {
            console.error(err);
        });
    };

    useEffect(() => {
        fetchPage();
    }, [id]);

    const renderTabContent = () => {
        switch (activeTab) {
            case 'memberships':
                return (
                    <div className="row">
                        {pageData?.memberships?.length ? pageData?.memberships.map((row) => (
                            <div className="col-md-4 mb-3" key={row.id}>
                                <div className="card">
                                    {/* <img src={`https://via.placeholder.com/150`} className="card-img-top" alt={`Group ${i}`} /> */}
                                    <img src={row.image? domain+row.image:"./assets/img/soft.png"} className="card-img-top" alt=""/>
                                    <div className="card-body">
                                        <h5 className="card-title">{row.name}</h5>
                                        <p className="card-text">{row.about? reduceText(row.about, 20, '...'): ''}</p>

                                        {/* <button className="btn btn-success">View</button> */}

                                        {/* <Link to={row.uuid? `/program?id=${row.uuid}`:'/'} className="btn btn-primary py-2 px-4"> <span>Read More</span></Link> */}

                                    </div>
                                </div>
                            </div>

                        )) : <></>}
                    </div>
                );
            case 'groups':
                return (
                    <div className="row">
                        {pageData?.groups?.length ? pageData?.groups.map((row) => (
                            <div className="col-md-4 mb-3" key={row.id}>
                                <div className="card">
                                    <img src={row.image? domain+row.image:"./assets/img/soft.png"} className="card-img-top" alt=""/>
                                    <div className="card-body">
                                        <h5 className="card-title">{row.name}</h5>
                                        <p className="card-text">{row.about? reduceText(row.about, 20, '...'): ''}</p>

                                        {/* <button className="btn btn-success">View</button> */}

                                        <Link to={row.uuid? `/chat?id=${row.uuid}&&mem=${row.chat_id}&&cat=group`:'/'} className="btn btn-primary py-2 px-4"> <span>View</span></Link>

                                    </div>
                                </div>
                            </div>

                        )) : <></>}
                    </div>
                );
            case 'publications':
                return (
                    <>

                        <div>
                            <div className="mb-3">
                                <label className="form-label">Title</label>
                                <input type="text" name="title" className="form-control" placeholder="Enter Title" onChange={handleInputChange} />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">About</label>
                                <textarea className="form-control" name="about" onChange={handleInputChange}></textarea>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Form Code</label>
                                <input type="text" name="form_id" className="form-control" placeholder="Enter Form Code" onChange={handleInputChange} />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Image</label>
                                <input 
                                    type="file" 
                                    name="image"
                                    className="form-control" 
                                    accept="image/*" 
                                    onChange={handleFileChange}
                                />
                            </div>

                            <button type='button' className="btn btn-primary mb-3" onClick={handleSubmit}>
                                Submit New
                            </button>
                        </div>

                        <div className="row">
                            {pageData?.researches?.length ? pageData?.researches.map((row) => (
                                <div className="col-md-4 mb-3" key={row.id}>
                                    <div className="card">
                                        <img src={row.image? domain+row.image:"./assets/img/soft.png"} className="card-img-top" alt=""/>
                                        <div className="card-body">
                                            <h5 className="card-title">{row.name}</h5>
                                            {row.access? <h5 className="card-title">({row.access})</h5>: null}
                                            <p className="card-text">{row.about? reduceText(row.about, 20, '...'): ''}</p>

                                            {/* <button className="btn btn-success">View</button> */}

                                            {row.form_id? 
                                                <div className='row mx-1'> <Link to={row.form_id? `/emyform/${row.form_id}`:'/'} className="mb-1 btn btn-primary py-2 px-4"> <span>View Form</span></Link>

                                                <Link to={row.form_id? `/emyformanswer/${row.form_id}`:'/'} className="btn btn-primary py-2 px-4"> <span>View Res</span></Link> </div>
                                            : null}

                                        </div>
                                    </div>
                                </div>

                            )) : <></>}
                        </div>
                        
                    </>
                );
            case 'policies':
                return (
                    <div className="row">
                        {[1, 2].map(i => (
                            <div className="col-md-6 mb-3" key={i}>
                                <div className="card">
                                    <div className="card-body">
                                        <h5 className="card-title">Document {i}</h5>
                                        <button className="btn btn-success">Preview</button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                );
            case 'edit profile':
                return (
                    <div className="card p-3">
                        <form>
                            <div className="mb-3">
                                <label className="form-label">Email</label>
                                <input name="new_email" onChange={handleInputChange} type="email" className="form-control" value={formData.new_email} />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Phone</label>
                                <input name="new_contact" onChange={handleInputChange} type="tel" className="form-control" value={formData.new_contact} />
                            </div>
                            <button type='button' onClick={sendProfile} className="btn btn-danger">Save</button>
                        </form>
                    </div>
                );
            case 'change password':
                return (
                    <div className="card p-3">
                        <form>
                            {/* <div className="mb-3">
                                <label className="form-label">Old Password</label>
                                <input type="password" className="form-control" />
                            </div> */}
                            <div className="mb-3">
                                <label className="form-label">New Password</label>
                                <input type="password" name="new_password" className="form-control" onChange={handleInputChange}/>
                            </div>
                            <button type='button' onClick={sendPassword} className="btn btn-danger">Change Password</button>
                        </form>
                    </div>
                );
            case 'settings':
                return (
                    <div className="card">
                        <div className="card-header">Settings</div>
                        <div className="card-body">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Option</th><th>Enable</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Receive Notifications</td>
                                        <td><input className='text-success' type="checkbox" defaultChecked /></td>
                                    </tr>
                                    <tr>
                                        <td>Show Online Status</td>
                                        <td><input className='text-success' type="checkbox" /></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                );
            default:
                return <p>No content.</p>;
        }
    };

    return (
        <>
            <Header page={'profile'} />

            <div className="container py-4">
                <div className="d-flex flex-wrap gap-2 mb-4 justify-content-center">
                    {tabs.map(tab => (
                        <button
                            key={tab}
                            className={`btn ${activeTab === tab ? 'btn-success' : 'btn-outline-success'} me-2 mb-2`}
                            onClick={() => setActiveTab(tab)}
                        >
                            {tab.toUpperCase()}
                        </button>
                    ))}
                </div>

                {renderTabContent()}
            </div>

            <Footer />
        </>
    );
}
